// extracted by mini-css-extract-plugin
export var active = "_a6-7";
export var container = "_a6-0";
export var evenWidth = "_a6-4";
export var large = "_a6-5";
export var outlet = "_a6-8";
export var slide = "_a6-2";
export var small = "_a6-6";
export var tab = "_a6-3";
export var tabs = "_a6-1";